import { render, staticRenderFns } from "./team.sessions.vue?vue&type=template&id=1171c3da&scoped=true&"
import script from "./team.sessions.vue?vue&type=script&lang=js&"
export * from "./team.sessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171c3da",
  null
  
)

export default component.exports